import React, { useState } from 'react';
import { Box, Card, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { VERSION_DISPLAY } from '../data/version';

const KUNDE_NAME = process.env.REACT_APP_KUNDE_NAME || '';

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh', bgcolor: '#dce8dc',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      p: 2,
    }}>
    {/* Logo + Kontext */}
     <Box sx={{ mb: 4, textAlign: 'center' }}>
       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
         <img src="/logo.png" alt="Baumwächter" style={{ height: 72, width: 'auto', objectFit: 'contain' }} />
       </Box>

       {KUNDE_NAME && (
           <Typography sx={{
             color: '#3d6b4a', fontWeight: 800, fontSize: '1.7rem',
             lineHeight: 1.15, letterSpacing: 0.2, mt: 2,
             pb: 1.25, borderBottom: '2px solid rgba(74,124,89,0.2)',
           }}>
             {KUNDE_NAME}
           </Typography>
         )}

       <Box sx={{
         display: 'inline-block', mt: KUNDE_NAME ? 1 : 1.5,
         px: 1.25, py: 0.3, borderRadius: 999,
         bgcolor: 'rgba(212,168,67,0.15)',
       }}>
         <Typography sx={{ color: '#b5923a', fontWeight: 700, fontSize: '0.65rem', letterSpacing: 1.5, textTransform: 'uppercase' }}>
           {VERSION_DISPLAY}
         </Typography>
       </Box>
     </Box>

      {/* Login Card */}
      <Card sx={{
        width: '100%', maxWidth: 420, p: 4, borderRadius: 3,
        boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
      }}>
        <Typography variant="h5" sx={{ color: '#4a7c59', textAlign: 'center', mb: 0.5, fontWeight: 300, fontSize: '1.6rem' }}>
          Willkommen zurück
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary', mb: 3 }}>
          Bitte melde dich an, um fortzufahren
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleSubmit}>
          <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>Email</Typography>
          <TextField
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="name@beispiel.de"
            type="email"
            required
            autoFocus
            sx={{
              mb: 2.5,
              '& .MuiOutlinedInput-root': {
                bgcolor: '#edf2f7',
                borderRadius: 2,
                '& fieldset': { border: 'none' },
              },
            }}
          />

          <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>Passwort</Typography>
          <TextField
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
            sx={{
              mb: 3,
              '& .MuiOutlinedInput-root': {
                bgcolor: '#edf2f7',
                borderRadius: 2,
                '& fieldset': { border: 'none' },
              },
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            sx={{
              py: 1.5, bgcolor: '#7a9e7e', fontSize: '1rem',
              '&:hover': { bgcolor: '#4a7c59' },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Einloggen'}
          </Button>
        </Box>
      </Card>
    </Box>
  );
}
